import EditDocument from "@material-symbols/svg-500/rounded/edit_document.svg?react";
import { memo } from "react";

import { IconCreator } from "./_utils/icon-creator";

import type { SVGIconProps } from "./_utils/icon-creator";

const EditDocumentIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: EditDocument });
	return <Icon />;
};

export default memo(EditDocumentIcon);
